/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Q12Inputs */

const et_faq_q12 = /** @type {(inputs: Faq_Q12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kuidas Webflow aitab luua kiirema ja paremini konverteeriva kodulehe?`)
};

const en_faq_q12 = /** @type {(inputs: Faq_Q12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How does Webflow help build a faster, higher-converting website?`)
};

/**
* | output |
* | --- |
* | "How does Webflow help build a faster, higher-converting website?" |
*
* @param {Faq_Q12Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const faq_q12 = /** @type {((inputs?: Faq_Q12Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Q12Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_faq_q12(inputs)
	return en_faq_q12(inputs)
});